class FixedElement extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.waypoint?.exists || !this.els?.item?.exists) return
    if (!window.BAO.MediaBreakpoints.isXsViewport) return

    this.placeholder = null
    this.createObserver = this.createObserver.bind(this)
    this.createObserver()
  }

  createPlaceholder () {
    if (this.placeholder) return

    const item = this.els.item.element
    const rect = item.getBoundingClientRect()
    const styles = window.getComputedStyle(item)

    const marginTop = parseFloat(styles.marginTop)
    const marginBottom = parseFloat(styles.marginBottom)
    const marginLeft = parseFloat(styles.marginLeft)
    const marginRight = parseFloat(styles.marginRight)

    const placeholder = document.createElement('div')

    placeholder.style.width = `${rect.width}px`
    placeholder.style.height = `${rect.height}px`
    placeholder.style.marginTop = `${marginTop}px`
    placeholder.style.marginBottom = `${marginBottom}px`
    placeholder.style.marginLeft = `${marginLeft}px`
    placeholder.style.marginRight = `${marginRight}px`

    item.before(item, placeholder)

    this.placeholder = placeholder
  }

  removePlaceholder () {
    if (!this.placeholder) return

    this.placeholder.remove()
    this.placeholder = null
  }

  createObserver () {
    const item = this.els.item.element

    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0]

      if (entry.isIntersecting) {
        this.removePlaceholder()
        item.classList.remove('is-fixed')
      } else {
        this.createPlaceholder()
        item.classList.add('is-fixed')
      }
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    })

    this.observer.observe(this.els.waypoint.element)
  }
}

if (!customElements.get('fixed-element')) {
  customElements.define('fixed-element', FixedElement)
}
